import URLSearchParams from '@ungap/url-search-params'
import { ChiptaElement, html, css, unsafeCSS } from 'chipta-libs/main.js';
import 'chipta-libs/components/font-awesome.js';
import 'chipta-libs/components/styled-button.js';


class ListItem extends ChiptaElement {

  static get properties() {
    return {
      url: {type: String}
    };
  }

  render() {

    if (this.url) {
      return html`
        <a class="link" href=${this.url}>${this.content}</a>
      `;
    } else {
      return html`
        <div class="link">${this.content}</div>
      `;
    }

  }

  get content() {

    return html`

      <div class="left-side">
        <slot></slot>
      </div>

      <div class="button-container">
        <styled-button type="positive" class="button">
          <button>
            ${gettext('tickets')}
            <font-awesome class="icon" icon="chevron-right" icon-style="custom"></font-awesome>
          </button>
        </styled-button>
      </div>

    `;

  }

  static get styles() {

    return css`

      :host {
        display: block;
        background: inherit;
      }

      .link {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        text-decoration: none;
        cursor: pointer;
      }

      .link:hover {
        background: #EEE;
      }

      .left-side {
				display: flex;
      }

      .button .icon {
        margin-left: 3px;
        font-size: 13px;
      }

      .button button {
        white-space: nowrap;
      }

      @media screen and (max-width: 500px) {

        .link {
          display: block;
        }

        .button-container {
          text-align: right;
        }

        .button {
          margin-top: 10px;
        }

      }

    `;

  }

}

customElements.define('list-item', ListItem);
